import { GenericVideoHandler } from './Generic';
import type { SimpleHandlerConfig } from './types';
/**
 * A handler to play video advertisements from Broadsign
 */
export class BroadsignVideoHandler extends GenericVideoHandler {
    protected _type: string;
    protected _videoId: string;
    constructor(config: SimpleHandlerConfig) {
        super(config);
        this._videoId = config.videoUrl;
        this._videoUrl = config.videoUrl;
        this._type = 'broadsign';
    }
}
